import { useQuery } from '@tanstack/react-query';
import { fetchMarketingResources, type MarketingResourcesData } from '../api/marketingResourcesApi';

export const marketingResourcesKeys = {
  all: ['financial-advisor', 'marketing-resources'] as const,
};

export function useMarketingResources() {
  return useQuery<MarketingResourcesData, Error>({
    queryKey: marketingResourcesKeys.all,
    queryFn: fetchMarketingResources,
  });
}
